import { NavLink } from 'react-router-dom';

/** Personal and collaborative notes, as the two tabs they are on iOS. */
export default function NotesTabs() {
  return (
    <nav className="tabs" aria-label="Notes">
      {/* `end`, or "/" would match every route and stay highlighted on /collab too. */}
      <NavLink to="/" end>
        My notes
      </NavLink>
      <NavLink to="/collab">Collaborative</NavLink>
    </nav>
  );
}
